"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lesson = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var lesson_details_layout_1 = require("./lesson-details-layout");
var lesson_details_banner_1 = require("../../components/entities/lesson-details-banner");
var lesson_card_1 = require("../../components/entities/lesson-card");
exports.Lesson = {
  name: 'Lesson',
  useConversation: true,
  useFollowers: true,
  useModerators: true,
  useConnections: true,
  useSpaces: true,
  usePublishStatus: true,
  useSlices: true,
  autoRoutes: ['details', 'list', 'update', 'create'],
  usePlatformActivity: true,
  platformActivity: {
    tab: 'own'
  },
  list: {
    banner: {
      content: 'Explore in-person and online {{SESSIONS}}'
    },
    grid: {
      spacing: 4
    },
    queryFields: "\n      banner { id name slug title description { text } alternateText openGraph { id image { id url } } }\n      description { id text html }\n      presenters { id name }\n      hours\n    "
  },
  components: {
    details: lesson_details_layout_1.LessonDetailsLayout,
    banner: lesson_details_banner_1.LessonDetailsBanner,
    card: lesson_card_1.LessonCard
  },
  form: {
    fieldsMemoize: false,
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'library'
    }, {
      name: 'community'
    }, {
      name: 'activity'
    }, {
      name: 'connections'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'banner',
        fieldSet: 'overview'
      },
      startDate: {
        type: 'datetimeRange',
        endFieldName: 'endDate',
        label: "Date & Time",
        fieldSet: 'overview'
      },
      endDate: {
        type: 'hidden',
        label: "End Date & Time",
        fieldSet: 'overview'
      },
      startDateTimeZone: {
        type: 'linked',
        entityTypeName: 'TimeZone',
        label: 'Start Date Time Zone',
        description: "Which {{TIME_ZONE}} applies to the start date?"
      },
      endDateTimeZone: {
        type: 'linked',
        entityTypeName: 'TimeZone',
        label: 'End Date Time Zone',
        description: "Which {{TIME_ZONE}} applies to the end date? Note: leave this blank if it's the same as the start date (this would likely only be different if the end date was beyond a daylight-savings change-over)."
      },
      description: {
        type: 'description'
      },
      presenters: {
        type: 'linkedMultiple',
        label: 'Presenters',
        description: 'Select one or more {{PEOPLE}} who are presenting this session',
        entityTypeName: 'Person',
        fieldSet: 'overview'
      },
      url: {
        type: 'url',
        fieldSet: 'overview'
      },
      places: {
        type: 'linkedMultiple',
        entityTypeName: 'Place',
        fieldSet: 'overview'
      },
      hours: {
        type: 'float',
        recommended: false,
        updateArgs: 'auto: false',
        fieldSet: 'overview',
        description: "The total number of hours allocated for this lesson. Note: leave this blank to use the difference between the start and end dates"
      },
      isVirtual: {
        type: 'boolean',
        label: 'Is Online?',
        description: "Is this an online-only session?"
      },
      fileAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset',
        fieldSet: 'library',
        description: "Does this {{LESSON}} have any associated {{FILE_ASSETS}}?"
      },
      podcasts: {
        type: 'linkedMultiple',
        entityTypeName: 'Podcast',
        fieldSet: 'library',
        description: "Does this {{LESSON}} have any associated {{PODCASTS}}?"
      },
      imageAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        fieldSet: 'library',
        description: "Does this {{LESSON}} have any {{IMAGE_ASSETS}}?"
      },
      roles: {
        type: 'linkedTable',
        entityTypeName: 'LessonRole',
        label: '{{PEOPLE}}',
        description: "Are there any other key {{PEOPLE}} involved in this {{SESSION}}?",
        fieldSet: 'community'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      quotes: {
        type: 'linkedMultiple',
        entityTypeName: 'Quote',
        fieldSet: 'library'
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        fieldSet: 'library'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        fieldSet: 'library'
      },
      documents: {
        type: 'linkedMultiple',
        entityTypeName: 'Document',
        fieldSet: 'activity'
      }
    })
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      id\n      name\n      slug\n      startDate\n      endDate\n      startDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n      endDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n\n      courses { ...EntityValueFields }\n      videos { ...EntityValueFields url }\n      description { ...ContentNodeFields }\n      isVirtual\n      url\n      places { ...EntityValueFields latitude longitude address1 address2 city { ...EntityValueFields state { id name abbr } country { id name slug shorthand } } }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      fileAssets { ...FileAssetValueFields }\n      podcasts { ...FileAssetValueFields }\n      imageAssets { ...EntityValueFields image { id url type width height } }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      links { ...EntityValueFields url }\n      documents { ...EntityValueFields }\n      quotes { ...EntityValueFields }\n      roles { ...EntityValueFields }\n    "], ["\n      id\n      name\n      slug\n      startDate\n      endDate\n      startDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n      endDateTimeZone { ...EntityValueFields abbreviation utcOffset }\n\n      courses { ...EntityValueFields }\n      videos { ...EntityValueFields url }\n      description { ...ContentNodeFields }\n      isVirtual\n      url\n      places { ...EntityValueFields latitude longitude address1 address2 city { ...EntityValueFields state { id name abbr } country { id name slug shorthand } } }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n      fileAssets { ...FileAssetValueFields }\n      podcasts { ...FileAssetValueFields }\n      imageAssets { ...EntityValueFields image { id url type width height } }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      links { ...EntityValueFields url }\n      documents { ...EntityValueFields }\n      quotes { ...EntityValueFields }\n      roles { ...EntityValueFields }\n    "])))
  }
};
var templateObject_1;